import React from "react";
import { Shield, TrendingUp, Zap, Brain, Database, RefreshCw } from "lucide-react";

const WhyEnterprisesSection = () => {
  const capabilities = [
    {
      icon: Shield,
      text: "Predict and prevent attacks before they occur"
    },
    {
      icon: TrendingUp,
      text: "Detect Shadow AI and adversarial manipulations in real time"
    },
    {
      icon: Zap,
      text: "Automatically investigate and remediate incidents"
    },
    {
      icon: Database,
      text: "Retain organizational threat knowledge and reasoning context"
    },
    {
      icon: RefreshCw,
      text: "Continuously adapt through feedback-driven machine learning"
    }
  ];

  return (
    <section className="py-16 md:py-20 bg-muted/30">
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto space-y-8">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground">
            Why Enterprises Choose AuraXP
          </h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold text-[#8932c8] mb-4">
                From Reactive Defense to Predictive Cyber Autonomy
              </h3>
              <p className="text-lg text-muted-foreground leading-relaxed">
                Enterprises today face sophisticated, AI-driven adversaries. Traditional detection models and human-only responses can't keep pace. AuraXP ushers in a new era of autonomous, cognitive cyber defense, combining behavioral intelligence, organizational learning, and trustworthy AI to protect your digital ecosystem.
              </p>
            </div>

            <div>
              <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-6">
                With AuraXP, organizations can:
              </h3>
              <div className="space-y-4">
                {capabilities.map((capability, index) => (
                  <div key={index} className="flex items-start gap-4">
                    <div className="flex-shrink-0 mt-1">
                      <capability.icon className="w-6 h-6 text-[#8932c8]" />
                    </div>
                    <p className="text-lg text-muted-foreground">{capability.text}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="pt-4">
              <p className="text-xl font-semibold text-foreground">
                AuraXP doesn't just detect. It learns, remembers, and responds.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyEnterprisesSection;
